export default __webpack_public_path__ + "static/media/mg.4d7239d1.svg";